import { loadComms } from '../common/api';

const comms = {
    name: 'comms',
    state: {
        loaded: false, 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.nid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.cid]: {
                        ...state.byId[payload.cid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcInsertAssoc: ( state, payload ) => {
            const [ cid, oid ] = payload.cid.split( '#' );
            let comm = state.byId[cid];
            if ( !comm ) {
                comm = {
                    assoc: []
                }
            } else if ( !comm.assoc ) {
                comm['assoc'] = [];
            }

            comm.assoc.push( payload.cdc );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [cid]: { 
                        ...comm
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.cid]: {
                        ...state.byId[payload.cid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.cid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveAssoc: ( state, payload ) => {
            const [ cid, oid ] = payload.crid.split( '#' );
            if ( !state.byId[cid] ) {
                return {
                    ...state
                }
            }

            let assoc = state.byId[cid].assoc.filter( f => ( f.caid !== payload.cid ) );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [cid]: { 
                        ...state.byId[cid],
                        assoc: assoc
                    }
                }
            }
        },
        loadedComms: ( state, payload ) => {
            return {
                ...state,
                loaded: true,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadComms( { aid, uid, channel } ) {
            const list = await loadComms( aid, uid, channel );
            let byId = {};
            if ( list && list.length ) {
                list.forEach( c => byId[c.cid] = c );
                dispatch.comms.loadedComms( byId );
            }
            return list;
        },
        insert( { cid, cdc } ) {
            const assoc = cid.match( '#' );
            if ( assoc ) {
                dispatch.comms.cdcInsertAssoc( { cid, cdc } );
            } else {
                dispatch.comms.cdcInsert( { cid, cdc } );
            }
        },
        modify( { cid, cdc } ) {
            dispatch.comms.cdcModify( { cid, cdc } );
        },
        remove( { cid } ) {
            const assoc = cid.match( '#' );
            if ( assoc ) {
                dispatch.comms.cdcRemoveAssoc( { cid } );
            } else {
                dispatch.comms.cdcRemove( { cid } );
            }
        },
        setCurrent( { cid } ) {
            dispatch.comms.setCurrentId( { cid } );
        }
    } )
}

export default comms;